<template>
    <div class="grid">
        <div class="col-12">
            <div class="card" v-if="permission?.includes('read')">
                <Toast />
                <Error :errors="errors" />

                <Fieldset legend="Filter" :toggleable="true" :collapsed="true" class="mb-3">
                    <Filter @submit="getDataTable()" ref="filter" />
                </Fieldset>

                <DataTable :value="dataTable" responsiveLayout="scroll" :loading="loading" dataKey="number"
                    @sort="onSort($event)" :resizableColumns="true">
                    <template #header>
                        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                            <div>
                                <Button :loading="loadingExcel" label="Export Excel" icon="pi pi-file-excel"
                                    class="p-button p-button-success mr-2 my-1 inline-block"
                                    @click="exportExcelCSV('xlsx')" />
                                <Button :loading="loadingCsv" label="Export CSV" icon="pi pi-file-excel"
                                    class="p-button p-button-success mr-2 my-1 inline-block"
                                    @click="exportExcelCSV('csv')" />
                            </div>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText v-model="search" placeholder="Cari..." @keyup.enter="getDataTable" />
                            </span>
                        </div>
                    </template>
                    <Column field="number" header="No." :style="{ width: '20px' }">
                        <template #body="slotProps">
                            {{ slotProps.data.number }}
                        </template>
                    </Column>
                    <Column field="region_name" header="Region">
                        <template #body="slotProps">
                            {{ slotProps.data.region_name }}
                        </template>
                    </Column>
                    <Column field="user_code" header="ASM Code">
                        <template #body="slotProps">
                            {{ slotProps.data.user_code }}
                        </template>
                    </Column>
                    <Column field="user_name" header="ASM Name">
                        <template #body="slotProps">
                            {{ slotProps.data.user_name }}
                        </template>
                    </Column>
                    <Column field="att_date_start" header="Date">
                        <template #body="slotProps">
                            {{ slotProps.data.att_date_start }}
                        </template>
                    </Column>
                    <Column field="att_time_start" header="Time Start">
                        <template #body="slotProps">
                            {{ slotProps.data.att_time_start }}
                        </template>
                    </Column>
                    <Column field="att_time_end" header="Time End">
                        <template #body="slotProps">
                            {{ slotProps.data.att_time_end }}
                        </template>
                    </Column>
                    <Column field="attendance_duration" header="Duration">
                        <template #body="slotProps">
                            {{ slotProps.data.attendance_duration }}
                        </template>
                    </Column>
                    <Column field="nama_tujuan_start" header="Location Type Start">
                        <template #body="slotProps">
                            {{ slotProps.data.nama_tujuan_start }}
                        </template>
                    </Column>
                    <Column field="location_start" header="Location Start">
                        <template #body="slotProps">
                            {{ slotProps.data.location_start }}
                        </template>
                    </Column>
                    <Column field="att_photo_start" header="Photo Start">
                        <template #body="slotProps">
                            <Image v-if="slotProps.data.att_photo_start != 'null'" :src="slotProps.data.att_photo_start"
                                :alt="slotProps.data.att_photo_start" width="100" preview />
                        </template>
                    </Column>
                    <Column field="att_latitude_start" header="Latitude Start">
                        <template #body="slotProps">
                            {{ slotProps.data.att_latitude_start }}
                        </template>
                    </Column>
                    <Column field="att_longitude_start" header="Longitude Start">
                        <template #body="slotProps">
                            {{ slotProps.data.att_longitude_start }}
                        </template>
                    </Column>
                    <Column field="nama_tujuan_end" header="Location Type End">
                        <template #body="slotProps">
                            {{ slotProps.data.nama_tujuan_end }}
                        </template>
                    </Column>
                    <Column field="location_end" header="Location End">
                        <template #body="slotProps">
                            {{ slotProps.data.location_end }}
                        </template>
                    </Column>
                    <Column field="att_photo_end" header="Photo End">
                        <template #body="slotProps">
                            <Image v-if="slotProps.data.att_photo_end != 'null'" :src="slotProps.data.att_photo_end"
                                :alt="slotProps.data.att_photo_end" width="100" preview />
                        </template>
                    </Column>
                    <Column field="att_latitude_end" header="Latitude End">
                        <template #body="slotProps">
                            {{ slotProps.data.att_latitude_end }}
                        </template>
                    </Column>
                    <Column field="att_longitude_end" header="Longitude End">
                        <template #body="slotProps">
                            {{ slotProps.data.att_longitude_end }}
                        </template>
                    </Column>
                    <Column header="Aksi" headerStyle="min-width:10rem;">
                        <template #body="slotProps">
                            <Button icon="pi pi-refresh" class="p-button-rounded p-button-danger mr-2"
                                @click="resetItem(slotProps.data)" v-if="permission.includes('update') && slotProps.data.can_reset == 'y'" />
                        </template>
                    </Column>
                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait. </template>
                    <template #footer>
                        In total there are {{ totalItemsCount ? totalItemsCount : 0 }} data.
                    </template>
                </DataTable>

                <Paginator v-model:rows="rows" v-model:first="offset" :totalRecords="totalItemsCount"
                    :rowsPerPageOptions="[10, 20, 30]">
                    <template>
                        {{ totalItemsCount }}
                    </template>
                </Paginator>

                <Reset @submit="getDataTable()" :item="item" ref="reset"/>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { numberingDatatable } from "../../utils/helpers";
import Filter from "../../components/report/attendance/Filter.vue";
import Error from "../../components/Error.vue";
import Reset from "../../components/report/attendance/Reset.vue";

export default {
    components: {
        Filter: Filter,
        Error: Error,
        Reset: Reset,
    },
    data() {
        return {
            // loading
            loading: false,
            loadingExcel: false,
            loadingCsv: false,

            //datatables
            data: null,
            dataTable: null,
            rows: 10,
            search: null,
            offset: null,
            field: null,
            sort: null,
            page: null,
            totalItemsCount: 0,

            // edit
            item: {},
        };
    },
    mounted() {
        const waitForRef = setInterval(() => {
            if (this.$refs.filter) {
                clearInterval(waitForRef);
                this.getDataTable();
            }
        }, 100);
        this.$store.commit("setErrors", {});
    },
    watch: {
        offset() {
            this.getDataTable();
        },
        rows() {
            this.getDataTable();
        },
    },
    computed: {
        ...mapGetters(["errors"]),
        ...mapGetters("auth", ["permission"]),
    },
    methods: {
        formatDate(value) {
            if (value) {
                return moment.utc(value).format("DD-MM-YYYY");
            }
        },
        // DATATABLE
        getDataTable() {
            this.loading = true;
            if (this.$refs?.filter) {
                this.$refs.filter.loading = true;
            }
            this.page = this.offset / this.rows + 1;

            this.axios({
                method: "GET",
                url: process.env.VUE_APP_ROOT_API + "web/attendance",
                params: {
                    search: this.search,
                    per_page: this.rows,
                    page: this.page,
                    order_by: this.field,
                    sort_by: this.sort,
                    region_id: this.$refs?.filter?.filters.region_id,
                    distributor_id: this.$refs?.filter?.filters.distributor_id,
                    user_code: this.$refs?.filter?.filters.user_code,
                    start_date: this.$refs?.filter?.period_start_label,
                    end_date: this.$refs?.filter?.period_end_label,
                },
            })
                .then((res) => {
                    this.data = res.data.data.data;
                    this.dataTable = numberingDatatable(
                        res.data.data.data,
                        this.page,
                        this.rows
                    );
                    this.totalItemsCount = res.data.data.total;
                    this.rows = parseInt(res.data.data.per_page);
                    this.loading = false;
                    this.$refs.filter.loading = false;
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.$refs.filter.loading = false;
                });
        },
        onSort(event) {
            this.field = event.sortField;
            this.sort = event.sortOrder == "1" ? "ASC" : "DESC";
            this.getDataTable();
        },
        // RESET
        resetItem(item) {
            this.item = item;

            this.$refs.reset.resetItemDialog = true;
        },
        // EXPORT
        exportExcelCSV(ext) {
            if (
                this.$refs?.filter?.period_start_label !== null &&
                this.$refs?.filter?.period_end_label !== null &&
                this.$refs?.filter?.period_start_label !== "Invalid date" &&
                this.$refs?.filter?.period_end_label !== "Invalid date"
            ) {
                if (ext == "xlsx") {
                    this.loadingExcel = true;
                } else if (ext == "csv") {
                    this.loadingCsv = true;
                }

                this.axios({
                    method: "GET",
                    url: process.env.VUE_APP_ROOT_API + "web/attendance/export",
                    responseType: "blob",
                    params: {
                        ext: ext,
                        region_id: this.$refs?.filter?.filters.region_id,
                        distributor_id: this.$refs?.filter?.filters.distributor_id,
                        user_code: this.$refs?.filter?.filters.user_code,
                        start_date: this.$refs?.filter?.period_start_label,
                        end_date: this.$refs?.filter?.period_end_label,
                    },
                })
                    .then((response) => {
                        let fileUrl = window.URL.createObjectURL(response.data);
                        let fileLink = document.createElement("a");

                        fileLink.href = fileUrl;

                        fileLink.setAttribute("download", "Report Attendance Export." + ext);

                        document.body.appendChild(fileLink);

                        fileLink.click();

                        if (ext == "xlsx") {
                            this.loadingExcel = false;
                        } else if (ext == "csv") {
                            this.loadingCsv = false;
                        }
                    })
                    .catch((err) => {
                        console.log(err);

                        if (ext == "xlsx") {
                            this.loadingExcel = false;
                        } else if (ext == "csv") {
                            this.loadingCsv = false;
                        }
                    });
            } else {
                alert("Pastikan rentang waktu sudah benar atau tidak kosong");
            }
        },
    },
};
</script>
